import { useReduxState } from 'hooks';
import { TemplateVariable } from 'components/common';
import { FormGroup, Code } from 'components/common/form';

interface Props {
  field: string;
  id: string;
  label: string;
}

const SiteSettingsCompletionCustomContent = ({ field, id, label }: Props) => {
  const { messages, theme } = useReduxState();

  const availableVariables = [
    'completionDate',
    'expirationDate',
    'tasksPercentage',
    'tasksPoints',
    'course',
    'user'
  ];

  return (
    <FormGroup label={label} style={{ marginTop: 25 }}>
      <div className="variables-title">
        {`${messages.siteSettingsEmailVariables}:`}
      </div>

      <div className="variables">
        {availableVariables.map((variable) => (
          <TemplateVariable key={variable} value={variable} />
        ))}
      </div>

      <Code
        field={field}
        id={id}
        placeholder={'<button href="www.google.fi">\n  Click here\n</button>'}
      />

      <style jsx>{`
        .variables-title {
          color: ${theme.textColorLighter};
          font-size: 1.4rem;
          margin-top: 5px;
        }
        .variables {
          margin: 5px 0 10px;
        }
      `}</style>
    </FormGroup>
  );
};

export default SiteSettingsCompletionCustomContent;
